const resolveFileName = (fileOrName) => {
  if (Array.isArray(fileOrName)) {
    return resolveFileName(fileOrName[0]);
  }

  if (typeof fileOrName === 'string') {
    return fileOrName;
  }

  if (fileOrName && typeof fileOrName.name === 'string') {
    return fileOrName.name;
  }

  return '';
};

export const encodeFileName = (fileOrName) => {
  const fileName = resolveFileName(fileOrName).replace(/[\r\n]/g, '');

  if (!fileName) return '';

  const extensionIndex = fileName.lastIndexOf('.');
  const nameWithoutExtension = extensionIndex > 0
    ? fileName.substring(0, extensionIndex)
    : fileName;

  try {
    return encodeURI(nameWithoutExtension);
  } catch {
    return '';
  }
};
